import React from "react";
import { Search } from "lucide-react";
import "../../../style/product.css";

const SearchBar = ({
  placeholder,
  onSearch,
  onFilter,
}) => {
  return (
    <div className="search-bar-container">
      <div className="product-search-bar">
        <Search className="product-search-icon" />
        <input
          type="text"
          placeholder={placeholder}
          className="product-search-input"
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
      {/* <button className="product-filter-button" onClick={onFilter}>
        <FilterIcon />
        Filters
      </button> */}
    </div>
  );
};

export default SearchBar;
